import './SectionHeaderComponent.scss';

/**
 * Header component to display a line and title for sections in the symbol details view
 * @param {string} title - The title to display.
 * @param {string} linkURL - (Optional) URL for the link on the right side of the header.
 * @param {string} linkMessage - (Optional) i18n key for the link message to display on the right side of the header.
 * @returns {JSX.Element} The rendered header component.
 */
const HeaderComponent = ({ title, linkURL = undefined, linkMessage = undefined }) => {
  return (
    <div className="header-container">
      <div className="header-line">
        <div className="header-line-golden"></div>
        <div className="header-line-gray"></div>
      </div>
      <div className="header-title-section">
        <div className="header-title">{title}</div>
        {linkURL && linkMessage && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={linkURL}
            className="header-link"
          >
            {linkMessage}
          </a>
        )}
      </div>
    </div>
  );
};

export default HeaderComponent;
